import { RequestHelper } from '../Helpers/RequestHelper.js';

export class PmSiteSettings {
	
	constructor(pmApi){
		this.pmApi = pmApi;
		
	}	

	/**
	 * Pull settings from api 
	 * @param  String siteToken       [description]
	 * @param  {function successCallback [description]
	 * @param  function errorCallback   [description]
	 */
	getPmSettings(siteToken, data, successCallback, errorCallback){		
		RequestHelper.ajax('GET', 
			this.pmApi.getURL() +'/siteSettings/' + siteToken, 
			data,
			successCallback, 
			errorCallback 
		);
	}

	/**
	 * To store in api database settings
	 * @param  string siteToken       [description]
	 * @param  Object data            [description]
	 * @param  function successCallback [description]
	 * @param  function errorCallback   [description]
	 */
	savePmSettings(siteToken, data, successCallback, errorCallback){		
		RequestHelper.ajaxv2({
			method: 'POST',
			url: this.pmApi.getURL() +'/siteSettings/save/' + siteToken, 
			data,
			successCallback, 
			errorCallback 
		});
	}

}